/**
 * Check if the given JSONValue is a JSONObject.
 *
 * @param {JSONValue} value - a JSON value to verify
 * @returns {boolean} - Returns true if the given value looks like a JSON object.
 */
export function isJSONValueObject(value) {
    return typeof value === 'object' && !(value instanceof Array);
}
